import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import './ServicePages.css';
import { fadeInUp } from '../constants/animations';

function SquareIntegrations() {
  return (
    <main className="service-page">
      <div className="service-container">
        <motion.div className="service-hero" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.25 }}>
          <motion.h1 variants={fadeInUp} custom={0}>Square Integrations</motion.h1>
          <motion.p variants={fadeInUp} custom={1}>Connect payments, invoices, and customer data directly into your workflow.</motion.p>
        </motion.div>

        <div className="service-section">
          <motion.div className="service-feature" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }} variants={fadeInUp} custom={0}>
            <h4>Payment collection</h4>
            <p>Get paid faster with seamless checkout flows.</p>
          </motion.div>
          <motion.div className="service-feature" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }} variants={fadeInUp} custom={1}>
            <h4>Invoice automation</h4>
            <p>Generate and send invoices without manual work.</p>
          </motion.div>
          <motion.div className="service-feature" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }} variants={fadeInUp} custom={2}>
            <h4>Unified data</h4>
            <p>Keep customer and payment data in sync.</p>
          </motion.div>
        </div>

        <motion.div className="service-block" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.25 }} variants={fadeInUp} custom={0}>
          <h3>What you get</h3>
          <ul className="service-list">
            <li>Square payments and invoices connected</li>
            <li>Automated receipts and follow‑ups</li>
            <li>Sync customer records</li>
            <li>Clean reporting for finance</li>
          </ul>
        </motion.div>

        <div className="service-split">
          <motion.div className="service-split-card" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }} variants={fadeInUp} custom={0}>
            <h4>Who it’s for</h4>
            <p>Businesses that want payments and reporting in one place.</p>
          </motion.div>
          <motion.div className="service-split-card" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }} variants={fadeInUp} custom={1}>
            <h4>Works with your stack</h4>
            <p>We integrate Square into your current workflow.</p>
          </motion.div>
        </div>

        <motion.div className="service-cta" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.35 }} variants={fadeInUp} custom={0}>
          <Link to="/plans">Get Started</Link>
        </motion.div>
      </div>
    </main>
  );
}

export default SquareIntegrations;
